const NextSlideIcon = (): JSX.Element => {
  return (
    <svg
      width='29'
      height='19'
      viewBox='0 0 29 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M27.3308 9.76979L28.0379 10.4769C28.4284 10.0864 28.4284 9.4532 28.0379 9.06268L27.3308 9.76979ZM27.3308 8.76979L0.66406 8.76986L0.664065 10.7699L27.3308 10.7698L27.3308 8.76979ZM19.7046 18.8103L28.0379 10.4769L26.6236 9.06269L18.2904 17.3961L19.7046 18.8103ZM28.0379 9.06268L19.7045 0.729414L18.2903 2.14363L26.6237 10.4769L28.0379 9.06268Z'
        fill='#003243'
      />
    </svg>
  );
};

export default NextSlideIcon;
